import { useState } from 'react';
import { Button, Form, Input, Modal } from 'semantic-ui-react';


import api from '../../apis/api'
import { SuccessToast, ErrorToast } from '../Toasters';
import UpdateEditor from './UpdateEditor'

const AddUpdateModal = ({getPortalUpdates}) => {

    const [modal, setModal] = useState(false)
    const [updateNumber, setUpdateNumber] = useState("")

    
    const onSubmit = (updateNote) => {
        if (updateNote === "") {
            ErrorToast('Please add a note')
            return
        }
        if (updateNumber === "") {
            ErrorToast('Please add update number')
            return
        }
        api.post('/portalupdates', { note: updateNote, updateNumber: updateNumber })
            .then(r => {
                getPortalUpdates()
                setUpdateNumber("")
                SuccessToast('Release Note Submitted', 'Portal release note has been submitted')
                setModal(false)

            })
            .catch(err => {
                ErrorToast(err)
            })
    }

    return (
        <Modal
            open={modal}
            onClose={() => setModal(false)}
            onOpen={() => setModal(true)}
            trigger={<Button primary>Create New Update Notes</Button>}>
            <Modal.Content>
                    <Form>
                        <Form.Field>
                            <label>Portal Update</label>
                            <Input type="text" placeholder="Update Number" name="updateNumber" value={updateNumber} onChange={(e, d) => setUpdateNumber(d.value)} required />
                        </Form.Field>
                        <UpdateEditor data={""} callback={onSubmit} />
                    </Form>
            </Modal.Content>
        </Modal>

    )
}
export default AddUpdateModal